import { createContext, useReducer, useEffect } from 'react';
import Cookies from 'js-cookie';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, user: action.payload };
    case 'LOGOUT':
      return { ...state, user: null };
    case 'AUTH_IS_READY':
      return { ...state, authIsReady: true };
    default:
      return state;
  }
};

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    authIsReady: false,
  });

  useEffect(() => {
    let user = null;
  
    // Attempt to get the user from a cookie first
    const userCookie = Cookies.get('user');
    console.log('User cookie:', userCookie);
    if (userCookie) {
      try {
        const decodedCookie = decodeURIComponent(userCookie);
        user = JSON.parse(decodedCookie); // Assign to the outer variable
        console.log('User from cookie:', user);
      } catch (error) {
        console.error("Error parsing user cookie:", error);
      }
    } else {
      // If no cookie, fall back to localStorage
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          user = JSON.parse(storedUser);
          console.log('User from localStorage:', user);
        } catch (error) {
          console.error("Error parsing user from localStorage:", error);
        }
      }
    }
  
    if (user) {
      dispatch({ type: 'LOGIN', payload: user });
    }
    // Mark authentication as ready
    dispatch({ type: 'AUTH_IS_READY' });
  }, []);
  

  console.log('AuthContext state: ', state);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};
